import { CellText } from "components/Omnisearch/helpComponents/CellText";
import { SubmissionStatus } from "generated-graphql/graphql";
import { STATUS_LABELS } from "utils/submissionStatusLabels";

export function SubmissionStatusCell({
  status,
}: {
  status?: SubmissionStatus | string | null;
}) {
  let statusValue: SubmissionStatus | string = SubmissionStatus.NotStarted;
  if (typeof status === "string") {
    if (status.trim()) {
      statusValue = status;
    }
  } else if (status) {
    statusValue = status;
  }

  const label = STATUS_LABELS[statusValue] ?? String(statusValue);

  return (
    <CellText variant="body2" noWrap>
      {label}
    </CellText>
  );
}
